import React, { ReactElement } from 'react'
import styles from './Footer.module.css'
import Markdown from '../atoms/Markdown'
import { useSiteMetadata } from '../../hooks/useSiteMetadata'
import { Link } from 'gatsby'
import MarketStats from '../molecules/MarketStats'
import BuildId from '../atoms/BuildId'

export default function Footer(): ReactElement {
  const { copyright, termsOfServiceLink, privacyPolicyLink } = useSiteMetadata()
  const year = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <BuildId />
        <MarketStats />

        <div className={styles.copyright}>
          © {year} <Markdown text={copyright} /> —{' '}
          <a href={termsOfServiceLink}>Terms</a>
          {' — '}
          <a href={privacyPolicyLink}>Privacy</a>
        </div>
      </div>
    </footer>
  )
}
